'use client';
import { useTranslation } from '@/i18n/LanguageProvider';

export default function PrivacyPage() {
  const { t } = useTranslation();
  return (
    <div>
      <section className="bg-gradient-to-br from-primary-600 to-secondary-600 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-bold mb-4">{t('privacy.title')}</h1>
          <p className="text-white/80">{t('privacy.lastUpdated')}: {t('privacy.date')}</p>
        </div>
      </section>
      <section className="py-16 bg-white dark:bg-gray-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-lg prose-gray max-w-none">
          <p className="text-gray-600 dark:text-gray-300 text-lg mb-8">{t('privacy.intro')}</p>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('privacy.s1Title')}</h2>
          <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mt-8 mb-3">{t('privacy.s1aTitle')}</h3>
          <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
            {['s1a1','s1a2','s1a3','s1a4','s1a5'].map(k=><li key={k}>{t(`privacy.${k}`)}</li>)}
          </ul>
          <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mt-8 mb-3">{t('privacy.s1bTitle')}</h3>
          <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
            {['s1b1','s1b2','s1b3','s1b4'].map(k=><li key={k}>{t(`privacy.${k}`)}</li>)}
          </ul>
          <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mt-8 mb-3">{t('privacy.s1cTitle')}</h3>
          <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
            {['s1c1','s1c2','s1c3','s1c4','s1c5'].map(k=><li key={k}>{t(`privacy.${k}`)}</li>)}
          </ul>
          <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mt-8 mb-3">{t('privacy.s1dTitle')}</h3>
          <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
            {['s1d1','s1d2','s1d3'].map(k=><li key={k}>{t(`privacy.${k}`)}</li>)}
          </ul>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('privacy.s2Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300 mb-4">{t('privacy.s2Intro')}</p>
          <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
            {['s2a','s2b','s2c','s2d','s2e','s2f'].map(k=><li key={k}>{t(`privacy.${k}`)}</li>)}
          </ul>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('privacy.s3Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300 mb-4">{t('privacy.s3Intro')}</p>
          <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
            {['s3a','s3b','s3c','s3d'].map(k=><li key={k}>{t(`privacy.${k}`)}</li>)}
          </ul>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('privacy.s4Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300 mb-4">{t('privacy.s4Intro')}</p>
          <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
            {['s4a','s4b','s4c','s4d'].map(k=><li key={k}>{t(`privacy.${k}`)}</li>)}
          </ul>
          <p className="text-gray-600 dark:text-gray-300 mt-4">{t('privacy.s4NoSell')}</p>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('privacy.s5Title')}</h2>
          <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
            {['s5a','s5b','s5c'].map(k=><li key={k}>{t(`privacy.${k}`)}</li>)}
          </ul>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('privacy.s6Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300">{t('privacy.s6Text')}</p>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('privacy.s7Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300 mb-4">{t('privacy.s7Intro')}</p>
          <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
            {['s7a','s7b','s7c','s7d','s7e','s7f'].map(k=><li key={k}>{t(`privacy.${k}`)}</li>)}
          </ul>
          <p className="text-gray-600 dark:text-gray-300 mt-4">{t('privacy.s7Contact')}</p>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('privacy.s8Title')}</h2>
          <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
            {['s8a','s8b','s8c','s8d'].map(k=><li key={k}>{t(`privacy.${k}`)}</li>)}
          </ul>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('privacy.s9Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300">{t('privacy.s9Text')}</p>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('privacy.s10Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300">{t('privacy.s10Text')}</p>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('privacy.s11Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300">{t('privacy.s11Text')}</p>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('privacy.s12Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300">{t('privacy.s12Text')}</p>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('privacy.s13Title')}</h2>
          <div className="bg-gray-50 dark:bg-gray-900 rounded-xl p-6 mt-4">
            <p className="text-gray-600 dark:text-gray-300 mb-2"><strong>IteroGO LLC</strong></p>
            <p className="text-gray-600 dark:text-gray-300 mb-2">{t('privacy.s13privacy')}: <a href="mailto:privacidad@iterogo.com" className="text-primary hover:underline">privacidad@iterogo.com</a></p>
            <p className="text-gray-600 dark:text-gray-300 mb-2">{t('privacy.s13rights')}: <a href="mailto:soporte@iterogo.com" className="text-primary hover:underline">soporte@iterogo.com</a></p>
            <p className="text-gray-600 dark:text-gray-300">{t('privacy.s13general')}: <a href="mailto:hola@iterogo.com" className="text-primary hover:underline">hola@iterogo.com</a></p>
          </div>
        </div>
      </section>
    </div>
  );
}
